// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as SlabDataVm from "./SlabDataVm.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CurrencyMinor from "../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as CorePricingUtils from "../library/utils/CorePricingUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function getVm(active_campaign, new_campaign, slab_details, role) {
  return {
          campaign_name: new_campaign.campaign_name,
          vehicle_name: new_campaign.vehicle,
          region: new_campaign.region,
          status: "PENDING",
          created_on: Timestamp$Catalyst.now(undefined),
          created_by: CorePricingUtils.getNameFromRole(role),
          start_date: new_campaign.start_date,
          base_fare: {
            delta: Belt_Option.mapWithDefault(active_campaign, undefined, (function (param) {
                    return Caml_option.some(Currency.subtract(new_campaign.base_fare, CurrencyMajorMinorMapper.baseToCurrency(param[0].fare_details.base_fare)));
                  })),
            value: new_campaign.base_fare
          },
          free_duration: {
            delta: Belt_Option.mapWithDefault(active_campaign, undefined, (function (param) {
                    return new_campaign.free_duration - CorePricingUtils.fromMilliSecToMins(param[0].fare_details.free_duration) | 0;
                  })),
            value: new_campaign.free_duration
          },
          waiting_rate: {
            delta: Belt_Option.mapWithDefault(active_campaign, undefined, (function (param) {
                    return Caml_option.some(Currency.subtract(new_campaign.waiting_rate_per_min, CurrencyMajorMinorMapper.baseToCurrency(param[0].fare_details.waiting_rate_per_min)));
                  })),
            value: new_campaign.waiting_rate_per_min
          },
          free_kms: {
            delta: Belt_Option.mapWithDefault(active_campaign, undefined, (function (param) {
                    return new_campaign.free_kms - param[0].fare_details.free_slab.free_kms | 0;
                  })),
            value: new_campaign.free_kms
          },
          free_km_price_per_min: {
            delta: Belt_Option.mapWithDefault(active_campaign, undefined, (function (param) {
                    return Caml_option.some(Currency.subtract(new_campaign.free_km_price, CurrencyMajorMinorMapper.baseToCurrency(param[0].fare_details.free_slab.price_per_min)));
                  })),
            value: new_campaign.free_km_price
          },
          slabs: SlabDataVm.getVm(new_campaign.free_kms, slab_details)
        };
}

function getCampaignRequestParams(new_campaign, geo_region_id, vehicle_id, slab_details, iso_code) {
  var last_slab = List.nth(slab_details, List.length(slab_details) - 1 | 0);
  var other_slabs = List.filter(function (slab) {
          return slab.slab_km !== last_slab.slab_km;
        })(slab_details);
  return {
          geo_region_id: geo_region_id,
          vehicle_id: vehicle_id,
          name: new_campaign.campaign_name,
          start_instant: Timestamp$Catalyst.toFloat(new_campaign.start_date),
          core_structure_request: {
            base_fare: {
              currency: iso_code,
              minor_amount: CurrencyMinor.fromBase(CurrencyMajorMinorMapper.currencyToBase(new_campaign.base_fare))
            },
            waiting_rate_per_min: {
              currency: iso_code,
              minor_amount: CurrencyMinor.fromBase(CurrencyMajorMinorMapper.currencyToBase(new_campaign.waiting_rate_per_min))
            },
            free_duration: CorePricingUtils.fromMinsToMiliSec(new_campaign.free_duration),
            free_kms: new_campaign.free_kms,
            free_km_price_per_min: {
              currency: iso_code,
              minor_amount: CurrencyMinor.fromBase(CurrencyMajorMinorMapper.currencyToBase(new_campaign.free_km_price))
            },
            slab_pricing_request: {
              distance_time_pricing_request: List.map((function (s) {
                      return {
                              slab_km: s.slab_km,
                              price_per_min: {
                                currency: iso_code,
                                minor_amount: CurrencyMinor.fromBase(s.price_per_min)
                              },
                              price_per_km: {
                                currency: iso_code,
                                minor_amount: CurrencyMinor.fromBase(s.price_per_km)
                              }
                            };
                    }), other_slabs),
              last_slab_pricing_request: {
                price_per_km: {
                  currency: iso_code,
                  minor_amount: CurrencyMinor.fromBase(last_slab.price_per_km)
                },
                price_per_min: {
                  currency: iso_code,
                  minor_amount: CurrencyMinor.fromBase(last_slab.price_per_min)
                }
              }
            }
          }
        };
}

export {
  getVm ,
  getCampaignRequestParams ,
  
}
/* CorePricingUtils Not a pure module */
